import { makeStyles } from "@material-ui/styles";

export const useItemReturnStyles: any = makeStyles(
    (theme: { [key: string]: any }) => ({
        root: {
            //flexGrow: 1,
            // position: "relative",
            // overflowX: "auto",
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: "center",
            color: theme.palette.text.secondary,
        },
        table: {
            minWidth: 650,
        },
        tableRow: {
            "&:hover": {
                backgroundColor: "#e3e3e3",
            },
            cursor: "pointer"
        },
        tableCell: {
            fontSize: "15px",
            fontWeight: "bold"
        },
        textFieldErrorMessageStyle: {
            textAlign: "left",
            paddingLeft: ".5em",
            paddingTop: ".5em",
            color: "red",
        },
        tableStyles: {
            paddingTop: "2em",
            paddingBottom: "2em"
        },
        dialogMainTitle: {
            fontWeight: "bolder",
            fontSize: "1.3rem",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        dialogSubTitleArabic: {
            fontWeight: "bold",
            fontSize: "0.99rem",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        dialogSubTitle: {
            fontWeight: "bold",
            fontSize: "0.845rem",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        dialogMainTitleArabic: {
            fontWeight: "bolder",
            fontSize: "1.5rem",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        amountTitle: {
            fontWeight: "bolder",
            fontSize: "1.175rem",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        normalTextAdmin: {
            fontSize: "0.95rem",
            fontWeight: "normal",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
            textAlign: "center",
            marginLeft:"-50px"
        },
        normalText: {
            fontSize: "0.95rem",
            fontWeight: "normal",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        voucherTitle: {
            fontSize: "0.95rem",
            fontWeight: "normal",
            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        },
        itemDetailsTypography: {
            fontSize: "0.875rem",
            fontWeight: "bold",
            color: "black",
        },
        buttonProgress: {
            color: "#1b5e20",
            position: "absolute",
            left: "61%",
            marginTop: "0.5em",
        },
        clearButton: {
            marginTop: "1em",
            textAlign: "start",
            marginLeft: "1em",
        },
        itemDetailsButton: {
            marginTop: "1em",
            textAlign: "end",
        },
        buttonItemAddProgress: {
            color: "#1b5e20",
            position: "absolute",
            left: "86%",
            marginTop: "0.5em",
        },
        buttonItemReturnProgress: {
            color: "#1b5e20",
            position: "absolute",
            left: "67%",
            marginTop: "0.5em",
        },
        buttonauthenticationProgress: {
            color: "#1b5e20",
            position: "absolute",
            left: "65%",
            marginTop: "0.3em",
        },
        circularProgress: {
            color: "#1b5e20",
            position: "absolute",
            left: "58%",
            marginTop: "0.5em",
        },
    })
);
